import { IAuthRoles } from "@auth/firebase/interfaces";
import { CommonTemplate } from "@components/templates/common";
import { useLogin, useTranslation, useLink } from "@refinedev/core";
import { CanAccess } from "@refinedev/core";
import { FaGoogle } from "react-icons/fa6";

export const Login = () => {
    const { mutate: login } = useLogin();
    const { translate } = useTranslation();
    // const { data } = useIsAuthenticated()
    // logger.debug(data)
    // const dat = usePermissions()
    // console.log(dat)
    
    const Link = useLink();

    const onSubmit = (e: React.FormEvent<HTMLFormElement> & { currentTargeAuthenticated: any }) => {
        e.preventDefault();

        // get form data
        const formData = Object.fromEntries(
            new FormData(e.currentTargeAuthenticated).entries(),
        );

        // call login mutation
        login({ type: 'google', ...formData });

        // reset form data
        e.currentTarget.reset();
    }

    return <CommonTemplate>
        <div className="h-screen bg-base-200 overflow-hidden flex flex-col items-center justify-center">
            <div className="relative">
                <div className="hover:scale-105 transition-all absolute top-0 left-0 z-10 -translate-x-1/2 -translate-y-1/2 w-32 h-32 rounded-full bg-secondary"></div>
                <div className="hover:scale-105 transition-all absolute top-0 right-0 z-10 -translate-x-1/2 -translate-y-1/2 w-16 h-16 rounded-full bg-secondary"></div>
                <div className="hover:scale-105 transition-all absolute top-[30%] right-0 translate-x-[80%] w-24 h-24 rounded-full bg-secondary"></div>
                <div className="hover:scale-105 transition-all absolute top-[40%] left-0 z-10 translate-x-[70%] w-8 h-8 rounded-full bg-secondary"></div>
                <div className="hover:scale-105 transition-all absolute bottom-0 left-0 -translate-x-1/2 translate-y-[25%] w-32 h-32 rounded-full bg-secondary"></div>
                <div className="hover:scale-105 transition-all absolute bottom-0 right-0 z-10 translate-x-1/2 translate-y-[25%] w-20 h-20 rounded-full bg-secondary"></div>
                {/* <div className="absolute bottom-0 right-0 z-10 translate-x-1/2 translate-y-1/2 md:translate-x-full md:translate-y-full w-8 h-8 rounded-full bg-secondary"></div> */}
                <div className="card bg-base-100 w-80 shadow-2xl">
                    <form className="card-body" onSubmit={(e) => onSubmit(e as any)}>
                        <CanAccess resource="onboarding" action="create" params={{ domain: 'pro_band0' }}>
                            <h1 className="mt-2 text-secondary text-3xl font-semibold mx-auto">Hachimind<span className="text-primary text-2xl">{translate("page.login.professional")}</span></h1>
                        </CanAccess>
                        <CanAccess resource="onboarding" action="create" params={{ domain: 'user_band0' }}>
                            <h1 className="mt-2 text-secondary text-3xl font-semibold mx-auto">Hachimind<span className="text-primary text-2xl">{translate("page.login.users")}</span></h1>
                        </CanAccess>
                        {/* <div className="absolute top-0 left-0 w-10 h-10 rounded-full bg-secondary"></div> */}
                        <Link to="https://hachimind.com" className="link">
                            <figure>
                                <img className="w-48 hover:scale-105 transition-all" src="/hachimind.svg" alt="Hachi logo" />
                            </figure>
                        </Link>
                        <h2 className="card-title self-center">{translate("page.login.title")}</h2>
                        <button className="btn bg-red-400 btn-lg" type="submit">
                            <FaGoogle />
                            {translate("page.login.google")}
                        </button>
                    </form>

                    <CanAccess resource="onboarding" action="create" params={{ domain: 'pro_band0' }}>
                        <Link className="btn bg-primary btn-lg mx-4 mb-4" to="/onboarding">{translate("page.login.registry")}</Link>
                    </CanAccess>
                </div>
            </div>
        </div>
    </CommonTemplate>
}

